import React from 'react'
import { useSelector } from 'react-redux'

import useGames from 'utils/hooks/queries/games/useGames'
import useTournaments from 'utils/hooks/queries/tournaments/useTournaments'

import TournamentCategory from '.'
import TournamentsLoader from '../../components/Tournaments/components/Loader'
import { makeSelectUserFavoriteGames } from '../MainLayout/selectors'

export default function TournamentCategoriesWithData() {
  const userFavoriteGame = useSelector(makeSelectUserFavoriteGames())
  const { data: games, isPending } = useGames()
  const {
    tournaments,
    tournamentsQuery: { isPending: areTournamentsFetching },
  } = useTournaments()
  const userTournaments = tournaments?.filter((tournament) => tournament.isSubscribed) ?? []

  if (userTournaments.length <= 0 || isPending) {
    return null
  }

  if (areTournamentsFetching) {
    return <TournamentsLoader />
  }

  return (
    <>
      {userTournaments.map((tournament) => (
        <TournamentCategory
          key={tournament.id}
          tournament={tournament}
          games={games}
          favoriteGames={userFavoriteGame.toJS()}
        />
      ))}
    </>
  )
}
